<template lang="pug">
div(v-clickoutside='close' @keydown.esc='close')
  a(href="#" @click.prevent="isOpen = !isOpen;")
    slot
  .z-30.transition-all.ease-out.duration-300(ref="dropdown" :class="isOpen ? 'visible' : 'invisible'")
    .rounded.shadow-bottom.transform.transition-all.ease-out.duration-300(:class="[toggledClasses, customClasses]")
      slot(name="in-dropdown")
</template>

<script>
import { createPopper } from '@popperjs/core';

export default {
  name: 'GenericDropdown',
  props: {
    customClasses: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      isOpen: false,
    };
  },
  computed: {
    toggledClasses () {
      return this.isOpen ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0';
    },
  },
  watch: {
    isOpen () {
      this.$emit('toggle');
    },
  },
  mounted () {
    createPopper(this.$el, this.$refs.dropdown, {
      placement: 'bottom',
    });
  },
  methods: {
    close () {
      this.isOpen = false;
    },
  },
};
</script>
